import { cs as reactcs } from '@ews/react-translations';

const cs = {
...reactcs
}
export default cs
